<template>
    <div class="">
        <b-row class="text-center">
            <b-col cols="6">
                <md-button @click="cuotaContable" class="md-dense md-raised md-primary btn-info">{{ labels.activoPorDerechoUso }}</md-button>
            </b-col>
            <b-col cols="6">
                <md-button @click="cuotaFinanciera" class="md-dense md-raised md-primary btn-info">{{ labels.pasivoPorArrendamiento }}</md-button>
            </b-col>
        </b-row>
        <div v-if="showContable" class="text-center">
            <!-- Contable -->
            <div class="row col-12">
                <div class="d-flex justify-content-center align-items-end col-11">
                    <h1 class="md-title text-center"><b><i>{{ labels.activDerechoUso }}</i></b></h1>
                </div>
                <div class="d-flex justify-content-end col-1">
                    <md-button style="background-color: #2e507a; width: 40px; height: 40px;" class="md-fab md-primary" @click="generaExcelActDerUsoBrt()">
                        <md-icon>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M192 112L304 112L304 200C304 239.8 336.2 272 376 272L464 272L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 128C176 119.2 183.2 112 192 112zM352 131.9L444.1 224L376 224C362.7 224 352 213.3 352 200L352 131.9zM192 64C156.7 64 128 92.7 128 128L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 250.5C512 233.5 505.3 217.2 493.3 205.2L370.7 82.7C358.7 70.7 342.5 64 325.5 64L192 64zM291.2 329.6C283.2 319 268.2 316.8 257.6 324.8C247 332.8 244.8 347.8 252.8 358.4L290 408L252.8 457.6C244.8 468.2 247 483.2 257.6 491.2C268.2 499.2 283.2 497 291.2 486.4L320 448L348.8 486.4C356.8 497 371.8 499.2 382.4 491.2C393 483.2 395.2 468.2 387.2 457.6L350 408L387.2 358.4C395.2 347.8 393 332.8 382.4 324.8C371.8 316.8 356.8 319 348.8 329.6L320 368L291.2 329.6z"/></svg>
                        </md-icon>
                    </md-button>
                </div>
            </div>
            <div class="row col-md-12 justify-content-center" v-if="listCuotas != 0">
                <b-table
                    :items="listCuotas"
                    :fields="fieldsActDerUso"
                    hover
                    bordered
                    responsive
                    sticky-header="500px"
                    small
                    class="tblEstandar"
                    head-variant="custom-blue"
                    :per-page="perPage"
                    :current-page="currentPage"
                >
                    <template #cell(numero_cuota)="data">
                        <div class="text-right">{{ data.item.numero_cuota }}</div>
                    </template>
                    <template #cell(tasa)="data">
                        <div class="text-right">{{ formatDecimal(data.item.tasa) }}</div>
                    </template>
                    <template #cell(valor_canon)="data">
                        <div class="text-right">{{ formatNumber(data.item.valor_canon) }}</div>
                    </template>
                    <template #cell(activo_derecho_uso_bruto)="data">
                        <div class="text-right">{{ formatNumber(data.item.activo_derecho_uso_bruto) }}</div>
                    </template>
                    <template #cell(gasto_amortizacion)="data">
                        <div class="text-right">{{ formatNumber(data.item.gasto_amortizacion) }}</div>
                    </template>
                    <template #cell(amortizacion_acumulada)="data">
                        <div class="text-right">{{ formatNumber(data.item.amortizacion_acumulada) }}</div>
                    </template>
                    <template #cell(cambio_pasivo)="data">
                        <div class="text-right">{{ formatNumber(data.item.cambio_pasivo) }}</div>
                    </template>
                    <template #cell(activo_derecho_uso_neto)="data">
                        <div class="text-right">{{ formatNumber(data.item.activo_derecho_uso_neto) }}</div>
                    </template>
                </b-table>
                <div class="row">
                    <div class="col-md-3 d-flex justify-content-start">
                        Mostrando {{ filasMostradas }} filas de {{ listCuotas.length }}
                    </div>
                    <div class="col-md-6 d-flex justify-content-center">
                        <b-pagination
                        v-model="currentPage"
                        :total-rows="listCuotas.length"
                        :per-page="perPage"
                        align="center"
                        size="md"
                        class="custom-pagination"
                        ></b-pagination>
                    </div>
                    <div class="col-md-3 d-flex justify-content-end">
                        <label class="mr-2 mb-0">Filas por página:</label>
                        <b-form-select
                        v-model="perPage"
                        :options="[5, 10, 20, 50, 100, 500]"
                        size="sm"
                        style="width: 80px;"
                        ></b-form-select>
                    </div>
                </div>
            </div>
            <div class="row col-md-12 justify-content-center mt-3" v-else>
                <h5>{{ labels.noRow }}</h5>
            </div>
        </div>
        <div v-if="showFinanciera" class="text-center">
            <div class="row col-12">
                <div class="d-flex justify-content-center align-items-end col-11">
                    <h1 class="md-title text-center"><b><i>{{ labels.pasivoPorArrendamiento }}</i></b></h1>
                </div>
                <div class="d-flex justify-content-end col-1">
                    <md-button style="background-color: #2e507a; width: 40px; height: 40px;" class="md-fab md-primary" @click="generaExcelPasivoArrenda()">
                        <md-icon>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M192 112L304 112L304 200C304 239.8 336.2 272 376 272L464 272L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 128C176 119.2 183.2 112 192 112zM352 131.9L444.1 224L376 224C362.7 224 352 213.3 352 200L352 131.9zM192 64C156.7 64 128 92.7 128 128L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 250.5C512 233.5 505.3 217.2 493.3 205.2L370.7 82.7C358.7 70.7 342.5 64 325.5 64L192 64zM291.2 329.6C283.2 319 268.2 316.8 257.6 324.8C247 332.8 244.8 347.8 252.8 358.4L290 408L252.8 457.6C244.8 468.2 247 483.2 257.6 491.2C268.2 499.2 283.2 497 291.2 486.4L320 448L348.8 486.4C356.8 497 371.8 499.2 382.4 491.2C393 483.2 395.2 468.2 387.2 457.6L350 408L387.2 358.4C395.2 347.8 393 332.8 382.4 324.8C371.8 316.8 356.8 319 348.8 329.6L320 368L291.2 329.6z"/></svg>
                        </md-icon>
                    </md-button>
                </div>
            </div>
            <div class="row col-md-12 justify-content-center" v-if="listCuotas != 0">
                <b-table
                    :items="listCuotas"
                    :fields="fieldsPasivoArrend"
                    hover
                    bordered
                    responsive
                    sticky-header="500px"
                    small
                    class="tblEstandar"
                    head-variant="custom-blue"
                    :per-page="perPage"
                    :current-page="currentPage"
                >
                    <template #cell(numero_cuota)="data">
                        <div class="text-right">{{ data.item.numero_cuota }}</div>
                    </template>
                    <template #cell(tasa)="data">
                        <div class="text-right">{{ formatDecimal(data.item.tasa) }}</div>
                    </template>
                    <template #cell(valor_canon)="data">
                        <div class="text-right">{{ formatNumber(data.item.valor_canon) }}</div>
                    </template>
                    <template #cell(base_pasivo_arrendamiento)="data">
                        <div class="text-right">{{ formatNumber(data.item.base_pasivo_arrendamiento) }}</div>
                    </template>
                    <template #cell(cambio_pasivo)="data">
                        <div class="text-right">{{ formatNumber(data.item.cambio_pasivo) }}</div>
                    </template>
                    <template #cell(pago_capital)="data">
                        <div class="text-right">{{ formatNumber(data.item.pago_capital) }}</div>
                    </template>
                    <template #cell(intereses)="data">
                        <div class="text-right">{{ formatNumber(data.item.intereses) }}</div>
                    </template>
                    <template #cell(pasivo_arrendamiento)="data">
                        <div class="text-right">{{ formatNumber(data.item.pasivo_arrendamiento) }}</div>
                    </template>
                </b-table>
                <div class="row">
                    <div class="col-md-3 d-flex justify-content-start">
                        Mostrando {{ filasMostradas }} filas de {{ listCuotas.length }}
                    </div>
                    <div class="col-md-6 d-flex justify-content-center">
                        <b-pagination
                        v-model="currentPage"
                        :total-rows="listCuotas.length"
                        :per-page="perPage"
                        align="center"
                        size="md"
                        class="custom-pagination"
                        ></b-pagination>
                    </div>
                    <div class="col-md-3 d-flex justify-content-end">
                        <label class="mr-2 mb-0">Filas por página:</label>
                        <b-form-select
                        v-model="perPage"
                        :options="[5, 10, 20, 50, 100, 500]"
                        size="sm"
                        style="width: 80px;"
                        ></b-form-select>
                    </div>
                </div>
            </div>
            <div class="row col-md-12 justify-content-center mt-3" v-else>
                <h5>{{ labels.noRow }}</h5>
            </div>
        </div>
    </div>
</template>

<script>
import Contrato from '../../services/Contrato';
import ContratoCuota from '../../services/ContratoCuota';
import * as XLSX from "exceljs";
import TipoContrato from '../../services/TipoContrato';

export default {
    name:'CuotasContrato',
    props:['numContrato'],
    data: () => ({
        listCuotas : [],
        showContable : false,
        showFinanciera : false,
        listaContratos : [],
        valorCanon : '',
        canonArrendamiento : null,
        perPage: 500,
        currentPage: 1,
        fieldsActDerUso: [
            { key: 'numero_cuota', label: 'Nro.', sortable: false },
            { key: 'fecha_pago', label: 'Fecha cuota', sortable: false },
            { key: 'tasa', label: 'Tasa', sortable: false },
            { key: 'valor_canon', label: 'Valor canon', sortable: false },
            { key: 'activo_derecho_uso_bruto', label: 'Derecho uso Bruto', sortable: false },
            { key: 'gasto_amortizacion', label: 'Gasto amortización', sortable: false },
            { key: 'amortizacion_acumulada', label: 'Amortización acumulada', sortable: false },
            { key: 'cambio_pasivo', label: 'Cambio pasivo', sortable: false },
            { key: 'activo_derecho_uso_neto', label: 'Derecho uso Neto', sortable: false },
        ],
        fieldsPasivoArrend: [
            { key: 'numero_cuota', label: 'Nro.', sortable: false },
            { key: 'fecha_pago', label: 'Fecha cuota', sortable: false },
            { key: 'tasa', label: 'Tasa', sortable: false },
            { key: 'valor_canon', label: 'Valor canon', sortable: false },
            { key: 'base_pasivo_arrendamiento', label: 'Pasivo inicial', sortable: false },
            { key: 'cambio_pasivo', label: 'Cambio pasivo', sortable: false },
            { key: 'pago_capital', label: 'Pago capital', sortable: false },
            { key: 'intereses', label: 'Intereses', sortable: false },
            { key: 'pasivo_arrendamiento', label: 'Pasivo final', sortable: false },
        ],
        infoContrato : [],
        lstTipoContratos : []
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Cuotas',
                    noRow : "No hay registros",
                    contable : 'Contable',
                    financiera : 'Financiera',
                    date : 'Fecha cuota', //Fecha
                    tasas : '------Tasa------',
                    tasas1: '---Tasa---',
                    actDerUsoBrt : 'Derecho uso Bruto',
                    actDerNeto : 'Derecho uso Neto',
                    pasivoArrendamiento : 'Pasivo final', //Pasivo arrendamiento
                    pasivoPorArrendamiento : 'Pasivo por arrendamiento', //Pasivo arrendamiento
                    bajasDerechoUso : 'Bajas derecho de uso',
                    remedPasivPorArrendam : 'Remedición pasivo por arrendamiento',
                    pasivPorArrendamiento : 'Pasivo por arrendamiento',
                    gastoAmortizacion : 'Gasto amortización',
                    amortizacionAcumulada : 'Amortización acumulada',
                    gastoIntereses : 'Gasto intereses',
                    pagoArrendamiento : 'Pago arrendamiento',
                    agrupaPagoArrendamiento : 'Agrupación pago arrendamiento',
                    activDerechoUso : 'Activo por derecho de uso',
                    activDerechoUsoNeto : 'Derecho uso Neto',
                    informPasivArriendo : 'Informe pasivo arriendo',
                    amortDerechoUso : 'Amortización por derecho de uso',
                    cambioPasivo : 'Cambio pasivo',
                    tiempoAmortizacion : 'Tiempo amortización',
                    pagoCapital : 'Pago capital',
                    basePasivArrendamiento : 'Pasivo inicial',//'Base pasivo arrendamiento'
                    intereses : 'Intereses',
                    activoPorDerechoUso : 'Activo por derecho de uso',
                    cuotasFinancieras : 'Cuotas financieras',
                    valorCanon : 'Valor canon',
                    numCuota : 'Nro.', 
                }
            }else{
                return {
                    title : 'Fee',
                    noRow : "There are not records",
                    contable : 'Accountant',
                    financiera : 'Financial',
                    date : 'Date',
                    tasas : 'Rates',
                    actDerUsoBrt : 'Gross right-of-use asset',
                    actDerNeto : 'Net right asset',
                    pasivoArrendamiento : 'Lease liability',
                    bajasDerechoUso : 'You cancel the right of use',
                    remedPasivPorArrendam : 'Lease liability remeasurement',
                    pasivPorArrendamiento : 'Lease liability',
                    gastoAmortizacion : 'Depreciation expense',
                    amortizacionAcumulada : 'Accumulated amortization',
                    gastoIntereses : 'Interest expense',
                    pagoArrendamiento : 'Lease payment',
                    agrupaPagoArrendamiento : 'Lease payment grouping',
                    activDerechoUso : 'Asset for right of use',
                    activDerechoUsoNeto : 'Net right-of-use asset',
                    informPasivArriendo : 'Lease passive report',
                    amortDerechoUso : 'Amortization for right of use',
                    cambioPasivo : 'Passive change',
                    tiempoAmortizacion : 'Amortization time',
                    pagoCapital : 'Capital payment',
                    basePasivArrendamiento : 'Lease liability base',
                    intereses : 'Interests',
                    activoPorDerechoUso : 'Net right-of-use asset',
                    cuotasFinancieras : 'Financial fees',
                    valorCanon : 'Valor canon',
                    numCuota : '# Cuota', 
                }
            }
        },
        filasMostradas() {
            const end = this.currentPage * this.perPage;
            return end > this.listCuotas.length
                ? this.listCuotas.length
                : end;
        }
    },
    methods:{
        cuotaContable(){
            this.showContable = true
            this.showFinanciera = false
        },
        cuotaFinanciera(){
            this.showFinanciera = true
            this.showContable = false
        },
        async generaExcelActDerUsoBrt(){
            const { Workbook } = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("Activo por derecho de uso")

            // =======================
            // TÍTULO
            // =======================
            worksheet.addRow(['Activo por derecho de uso'])
            worksheet.mergeCells('A1:I1')
            worksheet.getCell('A1').font = { name: 'Arial', size: 12, bold: true }
            worksheet.getCell('A1').alignment = { horizontal: 'center' }

            // =======================
            // INFO CONTRATO
            // =======================
            const rowContrato = worksheet.addRow([
                'Contrato',
                this.numContrato,
                '',
                'Fecha inicial',
                this.infoContrato.fecha_inicial
            ])
            worksheet.mergeCells('F2:I2')

            // Negrita a etiquetas
            rowContrato.getCell(1).font = { name: 'Arial', size: 11, bold: true } // Contrato
            rowContrato.getCell(4).font = { name: 'Arial', size: 11, bold: true } // Tipo contrato

            const rowFechas = worksheet.addRow([
                'Tipo contrato',
                this.tipoContrato(this.infoContrato.tipo_contrato),
                '',
                'Fecha final',
                this.infoContrato.fecha_final
            ])
            worksheet.mergeCells('F3:I3')

            // Negrita a etiquetas
            rowFechas.getCell(1).font = { name: 'Arial', size: 11, bold: true } // Fecha inicial
            rowFechas.getCell(4).font = { name: 'Arial', size: 11, bold: true } // Fecha final

            // =======================
            // HEADER TABLA
            // =======================
            const headerRow = worksheet.addRow([
                '# Cuota',
                'Fecha cuota',
                'Tasa',
                'Valor canon',
                'Activo por derecho de uso bruto',
                'Gasto amortización',
                'Amortización acumulada',
                'Cambio pasivo',
                'Activo por derecho de uso neto'
            ])

            headerRow.font = { name: 'Arial', size: 11, bold: true }

            // =======================
            // DATA
            // =======================
            this.listCuotas.forEach(e => {
                worksheet.addRow([
                    e.numero_cuota,
                    e.fecha_pago,
                    this.formatDecimal(e.tasa),
                    this.formatNumber(e.valor_canon),
                    this.formatNumber(e.activo_derecho_uso_bruto),
                    this.formatNumber(e.gasto_amortizacion),
                    this.formatNumber(e.amortizacion_acumulada),
                    this.formatNumber(e.cambio_pasivo),
                    this.formatNumber(e.activo_derecho_uso_neto),
                ])
            })

            // =======================
            // ANCHO COLUMNAS
            // =======================
            worksheet.columns = [
                { width: 10 },
                { width: 15 },
                { width: 10 },
                { width: 15 },
                { width: 18 },
                { width: 15 },
                { width: 15 },
                { width: 15 },
                { width: 18 },
            ]

            // =======================
            // BORDES
            // =======================
            const border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            }

            worksheet.eachRow({ includeEmpty: false }, row => {
                row.eachCell(cell => {
                    cell.border = border
                })
            })
            
            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = "Activo por derecho de uso.xlsx"
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                })
            )

            downloadLink.style.display = "none"
            document.body.appendChild(downloadLink)
            downloadLink.click()
            downloadLink.remove()
        },
        async generaExcelPasivoArrenda() {

            const { Workbook } = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("Pasivo por arrendamiento")

            // =======================
            // TÍTULO
            // =======================
            worksheet.addRow(['Pasivo por arrendamiento'])
            worksheet.mergeCells('A1:I1')
            worksheet.getCell('A1').font = { name: 'Arial', size: 11, bold: true }
            worksheet.getCell('A1').alignment = { horizontal: 'center' }

            // =======================
            // INFO CONTRATO
            // =======================
            const rowContrato = worksheet.addRow([
                'Contrato',
                this.numContrato,
                '',
                'Fecha inicial',
                this.infoContrato.fecha_inicial
            ])
            worksheet.mergeCells('F2:I2')

            // Negrita a etiquetas
            rowContrato.getCell(1).font = { name: 'Arial', size: 11, bold: true } // Contrato
            rowContrato.getCell(4).font = { name: 'Arial', size: 11, bold: true } // Tipo contrato

            const rowFechas = worksheet.addRow([
                'Tipo contrato',
                this.tipoContrato(this.infoContrato.tipo_contrato),
                '',
                'Fecha final',
                this.infoContrato.fecha_final
            ])
            worksheet.mergeCells('F3:I3')

            // Negrita a etiquetas
            rowFechas.getCell(1).font = { name: 'Arial', size: 11, bold: true } // Fecha inicial
            rowFechas.getCell(4).font = { name: 'Arial', size: 11, bold: true } // Fecha final

            // =======================
            // HEADER TABLA
            // =======================
            const headerRow = worksheet.addRow([
                '# Cuota',
                'Fecha cuota',
                'Tasas',
                'Valor canon',
                'Pasivo inicial',
                'Cambio pasivo',
                'Pago capital',
                'Intereses',
                'Pasivo final'
            ])

            headerRow.font = { name: 'Arial', size: 11, bold: true }

            // =======================
            // DATA
            // =======================
            this.listCuotas.forEach(e => {
                worksheet.addRow([
                e.numero_cuota,
                e.fecha_pago,
                this.formatDecimal(e.tasa),
                this.formatNumber(e.valor_canon),
                this.formatNumber(e.base_pasivo_arrendamiento),
                this.formatNumber(e.cambio_pasivo),
                this.formatNumber(e.pago_capital),
                this.formatNumber(e.intereses),
                this.formatNumber(e.pasivo_arrendamiento)
                ])
            })

            // =======================
            // ANCHO COLUMNAS
            // =======================
            worksheet.columns = [
                { width: 10 },
                { width: 15 },
                { width: 10 },
                { width: 15 },
                { width: 18 },
                { width: 15 },
                { width: 15 },
                { width: 15 },
                { width: 18 },
            ]

            // =======================
            // BORDES
            // =======================
            const border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            }

            worksheet.eachRow({ includeEmpty: false }, row => {
                row.eachCell(cell => {
                    cell.border = border
                })
            })
            
            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = "Pasivo por arrendamiento.xlsx"
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                })
            )

            downloadLink.style.display = "none"
            document.body.appendChild(downloadLink)
            downloadLink.click()
            downloadLink.remove()
        },
        formatNumber(value) {
            return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value);
        },
        formatDecimal(value){
            return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(value);
        },
        tipoContrato(numTipContrato){
            const tipo = this.lstTipoContratos.find((tc) => tc.tipo_contrato == numTipContrato) 
            return tipo.descripcion
        }
    },
    mounted(){
        ContratoCuota.getContratoCuotaByNumContr(this.numContrato)
        .then((result) => {
            // console.log(result.data.detContrato);
            this.listCuotas = result.data.detContrato
        }).catch((err) => {
            console.log(err);
        });

        Contrato.getAllContratos()
        .then((res) => {

            // console.log(res.data.listContratos);
            this.listaContratos = res.data.listContratos
            this.valorCanon = this.listaContratos.find((cont) => cont.nro_contrato == this.numContrato)
            // console.log(this.valorCanon.canon_arrendamiento);
            this.canonArrendamiento = this.valorCanon.canon_arrendamiento

        }).catch((err) => console.log(err))

        Contrato.leaContrato(this.numContrato)
        .then((res) => {
            this.infoContrato = res.data.contrato[0]
            // console.log(this.infoContrato);
        })
        .catch((err) => console.log(err))

        TipoContrato.getAllTipoContrato()
        .then((res) => {
            // console.log(res.data.listTipoContrato);
            this.lstTipoContratos = res.data.listTipoContrato
        })
        .catch((err) => console.log(err))
    }
}
</script>
<style src="../main.css">
</style>
